'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import type Captcha from 'react-google-recaptcha';

// reCAPTCHA reports an unusable widget (unauthorised domain, blocked iframe) via error-callback at
// render time, when executeAsync has no promise to reject, and never reports it again. Without this
// latch the submit awaits a token that never arrives.
export const useCaptcha = () => {
  const $ = _c(2);
  const captchaRef = useRef(null);
  const unavailableRef = useRef(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      unavailableRef.current = true;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const onCaptchaErrored = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    const executeCaptcha = async () => {
      if (unavailableRef.current) {
        throw new Error("captcha unavailable");
      }
      return captchaRef.current?.executeAsync();
    };
    t1 = {
      captchaRef,
      onCaptchaErrored,
      executeCaptcha
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};